import { NgModule } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
	TranslateModule,
	TranslateService,
	TranslateLoader,
	MissingTranslationHandler,
} from '@ngx-translate/core';
import { missingTranslationHandler, translatePartialLoader } from 'app/config/translation.config';
import { SessionStorageService } from 'ngx-webstorage';

@NgModule({
	imports: [
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: translatePartialLoader,
				deps: [HttpClient],
			},
			missingTranslationHandler: {
				provide: MissingTranslationHandler,
				useFactory: missingTranslationHandler,
			},
		}),
	],
})
export class TranslationModule {
	constructor(translateService: TranslateService, sessionStorageService: SessionStorageService) {
		// if user have changed language and navigates away from the application and back to the application then use previously choosed language
		const langKey = sessionStorageService.retrieve('locale') ?? 'pt-br';
		translateService.setDefaultLang(langKey);
		translateService.use(langKey);
	}
}
